import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";

import AppsIcon from "@mui/icons-material/Apps";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";

import AppLauncher from "./AppLauncher";

export default function Layout() {
  const [launcherOpen, setLauncherOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement,
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    } else {
      await document.exitFullscreen();
    }
  };

  return (
    <>
      {/* FIXED TOP NAV */}
      <AppBar position="fixed" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            SPPL KIOSK
          </Typography>

          {/* Network status */}
          <IconButton disableRipple>
            {isOnline ? (
              <WifiIcon sx={{ color: "#22c55e" }} />
            ) : (
              <WifiOffIcon sx={{ color: "#ef4444" }} />
            )}
          </IconButton>

          <IconButton color="inherit" onClick={toggleFullscreen}>
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>

          <IconButton color="inherit" onClick={() => setLauncherOpen(true)}>
            <AppsIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* SPACER: pushes content below fixed AppBar */}
      <Box sx={{ height: 64 }} />

      <AppLauncher open={launcherOpen} onClose={() => setLauncherOpen(false)} />
    </>
  );
}
